module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_autumn-fae81ea2568d753a877190c22fcdfdb0.jpg";